import { render, staticRenderFns } from "./CustomColorSelect.vue?vue&type=template&id=26141fbf"
import script from "./CustomColorSelect.vue?vue&type=script&lang=ts"
export * from "./CustomColorSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports